module.exports = __webpack_public_path__ + "static/carlsbad-1-23c1dd3d7cbc76dd43ff4f08194bce6f.jpeg";